<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="titularesResiduosDesbaste"
	[displayWith]="displayTitularResiduosDesbaste"
	[value]="selectedTitularResiduosDesbaste"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
